import styled from 'styled-components';
import Icon from '@minecraft.icon';
import DropdownToggle from '@minecraft.dropdown-toggle';
import { Carousel } from 'react-responsive-carousel';
import { appConfig } from '@minecraft.app-config';

export const PrimaryMediaLabel = styled.span`
  background: ${(props) => props.theme.colors.primary.black};
  color: ${(props) => props.theme.colors.primary.white};
  padding: 0.1em 1.5rem;
  font-size: 0.85rem;
  font-weight: bold;
  position: absolute;
  top: -30px;
  right: -1px;
`;

export const CustomDropdownToggle = styled(DropdownToggle)`
  height: 1.5rem;
  cursor: pointer;
  background: url(${appConfig.svgRoot}menu-meatball.svg);
  background-position: center;
  background-repeat: no-repeat;
  padding-left: 1.5rem;
  top: -25px;
  position: absolute;
  right: -20px;

  :hover {
    background: url(${appConfig.svgRoot}menu-meatball.svg);
  }

  :active {
    background: url(${appConfig.svgRoot}menu-meatball.svg);
  }
`;

export const MediaWrapper = styled.div`
  border: 1px solid;
  padding: 1.5rem 3rem 0;
  margin-bottom: 4rem;
`;

export const MediaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4rem;
`;

export const MediaTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  text-transfrom: capitalize;
`;

export const MediaSubTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-left: 25px;
  margin-bottom: 3rem;
`;

export const MediaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const Media = styled.div`
  width: calc(100% * (1 / 3) - 50px);
  margin: 0 25px 50px;
  padding: 35px 20px;
  border: 1px solid ${(props) => props.theme.colors.primary.ltGrey1};
  position: relative;
  display: flex;
`;

export const HiddenMediaContainer = styled.div`
  padding: 3rem 0 1rem;
`;

export const CustomCarousel = styled(Carousel)`
  .control-arrow,
  .carousel.carousel-slider .control-arrow {
    opacity: 1;
  }

  .thumbs {
    text-align: center;
  }

  .thumb {
    border: none;
    vertical-align: middle;
  }

  .thumb img {
    filter: grayscale(1);
  }

  .thumb.selected img {
    filter: none;
  }

  .control-prev.control-arrow:before {
    border-right-width: 2rem;
  }

  .control-next.control-arrow:before {
    border-left-width: 2rem;
  }

  .control-arrow:before,
  .carousel.carousel-slider .control-arrow:before {
    border-top-width: 2rem;
    border-bottom-width: 2rem;
  }

  .carousel-status {
    bottom: 0;
    right: 0;
    top: inherit;
    margin-bottom: 0;
    font-size: 1.5rem;
    font-weight: bold;
  }
`;

export const MediaPageHeading = styled.h1`
  font-size: 2rem;
  margin-bottom: 3rem;
`;

export const StyledIcon = styled(Icon)`
  position: absolute;
  width: 3rem;
  height: 3rem;
  top: calc(50% - 2.5rem);
  left: calc(50% - 1.5rem);
`;
